import { inject } from "@angular/core";
import { CanMatchFn, GuardResult, MaybeAsync, Router } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { AuthStore } from "../../shared/store/auth.store";

export const AuthGuard: CanMatchFn = async (route, segments): Promise<GuardResult> => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const authStore = inject(AuthStore);

  const isUserAuthenticated = authService.isAuthenticated();
  if (!isUserAuthenticated) {
    return router.createUrlTree(["/auth/login"]);
  }

  const user = authStore.currentUser();
  if (user?.id === 0) {
    try {
      await authStore.fetchCurrentUser();
    } catch (err) {
      return router.createUrlTree(["/auth/login"]);
    }
  }

  return true;
};
